import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { hmLightTheme } from "../../../themes/hmTheme";
import CustomTable from "../../../unit/CustomTable";
import formatCurrency from "../../../unit/formatCurrency";
import HeaderLabelTitle from "../../../unit/HeaderLabelTitle";
import HtmlTip from "../../../unit/HtmlTip";
import GetCreditorUnparsedValue from "./GetCreditorUnparsedValue";
const Installment = ({ sourcedata }: any) => {
  const data = sourcedata?.tradeData?.installment;
  if (data == null || data == undefined) {
    return null;
  }
  const account_type_code = sourcedata?.account_type_code;
  const MOP_code = sourcedata?.MOP_code;

  const account_type_title = (account: any) => {
    if (account == "" || account == undefined) {
      return "";
    }
    let accounttitle = "";
    for (const key in account) {
      for (const type in account[key].type) {
        accounttitle = account[key].type[type];
      }
    }

    if (accounttitle && account_type_code[accounttitle]) {
      accounttitle = account_type_code[accounttitle];
    }
    return accounttitle;
  };

  const account_status = (accountRating: any) => {
    if (accountRating == "" || accountRating == undefined) {
      return "";
    }
    let accountstatus = "";

    if (accountRating && MOP_code[accountRating]) {
      accountstatus = MOP_code[accountRating];
    }
    return accountstatus;
  };

  const collectionNote = (dateClosed: any, closedIndicator: any) => {
    if (dateClosed == "" || dateClosed == undefined) {
      return "";
    }
    let note = "";
    if (dateClosed && dateClosed.content) {
      if (Date.parse(dateClosed.content) < Date.now()) {
        note = closedIndicator ? closedIndicator : "";
      } else {
        note = "Open";
      }
    }
    return note;
  };

  const paymentHistory = (history: any) => {
    if (history == "" || history == undefined) {
      return "";
    }
    let paymentText = "";
    let paymentTextArr = [];
    let paymentMessage = "";
    let paymentPop = "";
    let startDate = "";
    for (const key in history) {
      if (history[key].paymentPattern) {
        for (const val in history[key].paymentPattern) {
          paymentText += history[key].paymentPattern[val].text;
          startDate = history[key].paymentPattern[val].startDate.content;
        }
        break;
      }
    }
    if (paymentText) {
      paymentTextArr = paymentText.split("");
      let paymentCount = 0;
      for (const key in paymentTextArr) {
        if (paymentTextArr[key] == "1") {
          paymentPop += '<span style="color:green;">1</span>';
        } else {
          paymentPop += '<span style="color:red;">0</span>';
        }
      }
    }
    paymentMessage = paymentTextArr.length + " Months Ending " + startDate;

    return (
      <HtmlTip title={paymentPop} sx={{ backgroundColor: "White" }}>
        <Typography
          variant="body2"
          sx={{ color: "#00ccb1", cursor: "pointer" }}
        >
          {paymentMessage}
        </Typography>
      </HtmlTip>
    );
  };

  const ontimePayment = (history: any) => {
    if (history == "" || history == undefined) {
      return "";
    }
    let paymentText = "";
    let paymentOntime = "";
    for (const key in history) {
      if (history[key].paymentPattern) {
        for (const val in history[key].paymentPattern) {
          paymentText += history[key].paymentPattern[val].text;
        }
        break;
      }
    }
    if (paymentText) {
      let paymentTextArr = paymentText.split("");
      let paymentCount = 0;
      for (const key in paymentTextArr) {
        if (paymentTextArr[key] == "1") {
          paymentCount++;
        }
      }
      paymentOntime =
        ((paymentCount / paymentTextArr.length) * 100).toFixed(2) + "%";
    }
    return paymentOntime;
  };

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <HeaderLabelTitle
          title={
            `Installment ( <span style="color: #1976d2;">` +
            data.length +
            `</span> Records )`
          }
          suffix=""
        />
      </AccordionSummary>
      <AccordionDetails>
        <TableContainer
          sx={{
            maxWidth: "100%",
            width: "100%",
            wordBreak: "break-word",
            // overflowX: "hidden",
            overflow: "auto",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            borderRadius: 0,
            "& .MuiTableRow-head": {
              border: "none",
            },
          }}
        >
          <CustomTable size="small" aria-label="Installment">
            <TableHead>
              <TableRow>
                <TableCell>Date Closed</TableCell>
                <TableCell>Creditor</TableCell>
                <TableCell>Liability Ownership</TableCell>
                <TableCell>Date Opened</TableCell>
                <TableCell>Term(Mo)</TableCell>
                <TableCell>Original Balance</TableCell>
                <TableCell>Current Balance</TableCell>
                <TableCell>Monthly Payment Amount</TableCell>
                <TableCell>Account Status</TableCell>
                <TableCell>Past Due Amount</TableCell>
                <TableCell>Payment History</TableCell>
                <TableCell>On-Time Payment</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row: any, index: any) => (
                <TableRow
                  key={index}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{ fontFamily: hmLightTheme?.palette?.numberFontFamily }}
                  >
                    {row.dateClosed ? row.dateClosed.content : ""}
                  </TableCell>
                  <TableCell>
                    {GetCreditorUnparsedValue(row.subscriber)}
                  </TableCell>
                  <TableCell>
                    {row.ECOADesignator ? row.ECOADesignator : ""}
                  </TableCell>
                  <TableCell>
                    {row.dateOpened && row.dateOpened.content
                      ? row.dateOpened.content
                      : ""}
                  </TableCell>
                  <TableCell align="center">
                    {(() => {
                      if (
                        row.terms &&
                        typeof row.terms === "object" &&
                        Object.values(row.terms).length > 0 &&
                        Object.values(row.terms)[0]?.paymentScheduleMonthCount
                      ) {
                        const val = Object.values(row.terms)[0]
                          .paymentScheduleMonthCount;
                        const intVal = parseInt(val, 10);
                        return isNaN(intVal) ? "" : intVal;
                      }
                      return "";
                    })()}
                  </TableCell>
                  <TableCell
                    sx={{ fontFamily: hmLightTheme?.palette?.numberFontFamily }}
                  >
                    {row.original && row.original.balance
                      ? formatCurrency(row.original.balance)
                      : ""}
                    {row.highCredit ? formatCurrency(row.highCredit) : ""}
                  </TableCell>
                  <TableCell
                    sx={{ fontFamily: hmLightTheme?.palette?.numberFontFamily }}
                  >
                    {/* {row.dateEffective && row.dateEffective.content
                      ? row.dateEffective.content
                      : ""} */}
                    {row.currentBalance
                      ? formatCurrency(row.currentBalance)
                      : ""}
                  </TableCell>
                  <TableCell>
                    {Array.isArray(row.terms) &&
                    row.terms.length > 0 &&
                    row.terms[0].scheduledMonthlyPayment
                      ? formatCurrency(row.terms[0].scheduledMonthlyPayment)
                      : ""}
                  </TableCell>
                  <TableCell
                    sx={{ fontFamily: hmLightTheme?.palette?.numberFontFamily }}
                  >
                    {account_status(row.accountRating)}
                  </TableCell>

                  <TableCell
                    sx={{ fontFamily: hmLightTheme?.palette?.numberFontFamily }}
                  >
                    {formatCurrency(row.pastDue)}
                  </TableCell>
                  <TableCell>{paymentHistory(row.paymentHistory)}</TableCell>
                  <TableCell
                    sx={{ fontFamily: hmLightTheme?.palette?.numberFontFamily }}
                  >
                    {ontimePayment(row.paymentHistory)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </CustomTable>
        </TableContainer>
      </AccordionDetails>
    </Accordion>
  );
};

export default Installment;
